import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';

const Tag = ({ text, onClick }) => {
    const iconStyle = {
        marginLeft: '0.5rem'
    };
    return (
        <button
            type="button"
            className="btn btn-md-sm btn-dark m-1"
            onClick={() => onClick()}>
            {text}
            <CloseIcon
                style={iconStyle}
                className="icon icon-xs align-middle"
            />
        </button>
    );
};

Tag.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func
};

export default Tag;
